var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcDropdown2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 20,
    viewBox: "0 0 34 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4183 0H14.2782C14.2782 1.28931 13.2266 2.3314 11.9326 2.3314C10.6386 2.3314 9.587 1.28618 9.587 0H2.26688C1.0138 0 0 1.00767 0 2.25317V17.4339C0 18.6794 1.0138 19.6871 2.26688 19.6871H9.72553C9.63423 19.4398 9.58385 19.1738 9.58385 18.8953C9.58385 17.606 10.6354 16.5639 11.9294 16.5639C13.2234 16.5639 14.275 17.6091 14.275 18.8953C14.275 19.1738 14.2247 19.4398 14.1333 19.6871H31.4151C32.6682 19.6871 33.682 18.6794 33.682 17.4339V2.25317C33.6852 1.00767 32.6714 0 31.4183 0Z",
    fill: "#FABB00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51684 8.99411C4.32018 8.99411 4.97142 8.34681 4.97142 7.54832C4.97142 6.74984 4.32018 6.10254 3.51684 6.10254C2.71349 6.10254 2.06226 6.74984 2.06226 7.54832C2.06226 8.34681 2.71349 8.99411 3.51684 8.99411Z",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45043 13.7382C9.25377 13.7382 9.90501 13.0909 9.90501 12.2925C9.90501 11.494 9.25377 10.8467 8.45043 10.8467C7.64709 10.8467 6.99585 11.494 6.99585 12.2925C6.99585 13.0909 7.64709 13.7382 8.45043 13.7382Z",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45045 5.2168L3.51685 14.4673",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9326 2.33154V5.21685",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9326 6.6001V9.48853",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9326 10.8716V13.7569",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9326 15.1401V16.564",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6514 3.77441H26.9255",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0716 15.8506H23.3457",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0716 9.8418H30.5021",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0716 13.084H30.5021",
    stroke: "#767474",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdown2);
export default __webpack_public_path__ + "static/media/ic_dropdown2.46998b004cfb2630b40eba8632924d87.svg";
export { ForwardRef as ReactComponent };